import RequestCompOffAdminActionType from './RequestCompOffAdmin.types';

export const requestCompOffAdminStart = (compOffData: any) => ({
	type: RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_START,
	payload: compOffData,
});

export const requestCompOffAdminSuccess = (compOffData: any) => ({
	type: RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_SUCCESS,
	payload: compOffData,
});

export const requestCompOffAdminFailure = (error: unknown) => ({
	type: RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_FAILURE,
	payload: error,
});

export const requestCompOffAdminResponseChanged = () => ({
	type: RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_RESPONSE_CHANGED,
});

export const requestCompOffAdminResponseRestStart = () => ({
	type: RequestCompOffAdminActionType.REQUEST_COMPOFF_ADMIN_RESPONSE_REST_START,
});

export const getAllEmployeesCompOffAdminStart = (organisationData: any) => ({
	type: RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_START,
	payload: organisationData,
});

export const getAllEmployeesCompOffAdminSuccess = (employeesData: any) => ({
	type: RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_SUCCESS,
	payload: employeesData,
});

export const getAllEmployeesCompOffAdminFailure = (error: unknown) => ({
	type: RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_FAILURE,
	payload: error,
});

export const getAllEmployeesCompOffAdminResponseChanged = () => ({
	type: RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_CHANGED,
});

export const getAllEmployeesCompOffAdminResponseRestStart = () => ({
	type: RequestCompOffAdminActionType.GET_ALL_EMPLOYEES_COMPOFF_ADMIN_RESPONSE_REST_START,
});

export const getHolidaysCompOffAdminStart = () => ({
	type: RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_START,
});

export const getHolidaysCompOffAdminSuccess = (holidaysData: any) => ({
	type: RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_SUCCESS,
	payload: holidaysData,
});

export const getHolidaysCompOffAdminFailure = (error: unknown) => ({
	type: RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_FAILURE,
	payload: error,
});

export const getHolidaysCompOffAdminResponseChanged = () => ({
	type: RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_CHANGED,
});

export const getHolidaysCompOffAdminResponseRestStart = () => ({
	type: RequestCompOffAdminActionType.GET_HOLIDAYS_COMPOFF_ADMIN_RESPONSE_REST_START,
});

